export default {
  templates: [],
  pagination: {},
  template: {}
}
